import {Injectable, NgModule, inject, provideAppInitializer} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {provideTransloco, Translation, TranslocoLoader, TranslocoModule} from '@jsverse/transloco';
import {environment} from '../../environments/environment';
import {appVersion} from '../../environments/version';
import {AP_LANGS, LanguageService} from './language.service';

/** assets/i18n/{lang}.json を読む。リリースごとに版でキャッシュを切る。 */
@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        return this.http.get<Translation>(`./assets/i18n/${lang}.json?v=${appVersion}`);
    }
}

/**
 * 画面の多言語化 (日本語 / 英語)。ira-groupnet.app の transloco 構成と同形。
 *
 * <p>文言は assets/i18n/{ja,en}.json のキーで引く。訳が無いキーは日本語にフォールバックする。
 * 起動時に前回の言語 (端末保存) を読み込んでから画面を出す。ログイン後は AP_Preference の値で上書きする。
 */
@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: AP_LANGS.map((l) => ({id: l.id, label: l.label})),
                defaultLang: 'ja',
                fallbackLang: 'ja',
                missingHandler: {useFallbackTranslation: true, logMissingKey: !environment.production},
                reRenderOnLangChange: true,
                prodMode: environment.production,
            },
            loader: TranslocoHttpLoader,
        }),
        provideAppInitializer(() => {
            const language = inject(LanguageService);
            return firstValueFrom(language.init());
        }),
    ],
})
export class TranslocoRootModule {
}
